import React from 'react';
export function MethodSection() {
  return <section className="w-full bg-brown-primary text-cream py-20 px-4 text-center" data-id="element-65">
      <div className="max-w-4xl mx-auto" data-id="element-66">
        <span className="text-rose-gold font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-67">
          LA SOLUCIÓN
        </span>

        <h2 className="text-4xl md:text-5xl font-bold mb-8 font-serif" data-id="element-68">
          Presentamos: EL MÉTODO{' '}
          <span className="italic text-gold-soft" data-id="element-69">"PIEL DE VIDRIO"</span> EN
          CASA
        </h2>

        <p className="text-xl md:text-2xl text-cream/80 max-w-2xl mx-auto leading-relaxed" data-id="element-70">
          La guía definitiva para mujeres mexicanas que quieren resultados
          reales sin dramas financieros.
        </p>
      </div>
    </section>;
}